import styled from 'styled-components/macro';
import { colorBlackTransparent50 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
export const PreviewContentStyled = styled.div `
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  padding: 24px 0;

  ${ADAPTIVE.minWidth.tablet} {
    max-width: 348px;
    align-items: center;
    justify-content: center;
    padding: 0;
    height: 100%;
  }

  ${ADAPTIVE.minWidth.desktopLg} {
    ${({ isRightToLeft }) => isRightToLeft
    ? `
        margin-left: 240px;
        margin-right: auto;
      `
    : `
        margin-left: 112px;
        margin-right: 230px;
      `}
  }
`;
export const ImageBgStyled = styled.div `
  display: flex;
  width: auto;
  height: 660px;

  ${ADAPTIVE.minWidth.tablet} {
    width: calc(100% - 61px);

    ${({ isRightToLeft }) => (isRightToLeft ? 'margin-right: 85px;' : 'margin-left: 85px;')}
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: calc(100% + 12px);

    ${({ isRightToLeft }) => (isRightToLeft ? 'margin-right: -12px;' : ' margin-left: -12px;')}
  }
`;
export const ImageBgInnerStyled = styled.div `
  flex: 1;
  height: 660px;
  background-color: ${colorBlackTransparent50};

  img {
    object-fit: cover;
    object-position: 50% 50%;
    height: 100%;
  }
`;
// Styles for wrapper 'Frame component | Mobile'
const AppDeviceFrameWrapper = styled.div `
  position: relative;
  display: flex;
  box-sizing: border-box;
  height: 328px;
  overflow: hidden;
  justify-content: center;
  align-items: center;

  ${ADAPTIVE.minWidth.tablet} {
    position: absolute;
    height: 100%;
    overflow: initial;
    z-index: 1;
    justify-content: flex-start;

    ${({ isRightToLeft }) => (isRightToLeft ? 'right: 50%;' : 'left: 50%;')}
  }

  ${ADAPTIVE.minWidth.desktop} {
    ${({ isRightToLeft }) => (isRightToLeft ? 'margin-right: -152px;' : 'margin-left: -152px;')}
  }
`;
// Styles for wrapper 'Frame component | Mobile'
export const AppMobileFrameWrapperStyled = styled(AppDeviceFrameWrapper) `
  width: 100%;

  ${ADAPTIVE.minWidth.tablet} {
    width: 255px;
    height: 660px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: 302px;
  }
`;
// Styles for wrapper 'Frame component | Tablet'
export const AppTabletFrameWrapperStyled = styled(AppDeviceFrameWrapper) `
  ${ADAPTIVE.minWidth.tablet} {
    height: 660px;
    width: 350px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: 433px;
  }
`;
export const CustomFlexWrapper = styled(FlexWrapper) `
  flex-wrap: wrap;
  justify-content: start;

  flex-direction: ${({ isRightToLeft }) => (isRightToLeft ? 'row-reverse' : 'row')};
`;
